import "@babel/polyfill";
import $ from 'jquery';
import loader from './__modules/loader';
import multiplied_word from "./__modules/multiplied_word";
import side_menus from "./__modules/side_menus";
import contactSection from "./__modules/contact";
import articleInfoSection from "./__modules/articleInfoSection";
import aboutMainSection from "./__modules/aboutMainSection";
import aboutInfoSection from "./__modules/aboutInfoSection";
import sectionProcess from "./__modules/sectionProcess";
import sectionContact from "./__modules/contactHomeSection";
import HomeWorkSection from "./__modules/HomeWorkSection";
import projects from "./__modules/project";
import heroSection from "./__modules/heroSection";
import banner from "./__modules/aboutBanner";
import sectionServices from "./__modules/sectionServices";
import locomotiveInit from "./__modules/locomotive";
import footer from "./__modules/footer";

document.addEventListener('DOMContentLoaded', () => {
	locomotiveInit();
	
	if ($('.loader').length) {
        loader(() => {
            if ($('.works').length) {
                HomeWorkSection();
            }
        });
    } 

	if($('.hero-section').length){
		heroSection();
	}

	if($('.article-description').length){
		articleInfoSection();
 	 }

	if($('.hero-about').length) {
		aboutMainSection();
	}

	if($('.about-us-section').length) {
		aboutInfoSection();
	}
	if($('.processes').length) {
		sectionProcess();
	}
	if($('.contact').length) {
		sectionContact();
	}

	if($('.multiplied-word').length){
		multiplied_word();
	}

	if($('.project').length){
		projects();
	}
  
  	if($('.hero-contact').length) {
		contactSection();
	}
  
  	if($('.banner').length) {
		banner();
	}
  	
	if($('.service-items').length) {
		sectionServices();
	}
	
	if($('.footer').length) {
		footer();
	}
});

window.addEventListener('load', () => {
	side_menus();
    
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        document.body.classList.add('ios');
    }
});

window.addEventListener('resize', () => {
});

